import React, { useEffect, useState } from 'react';
import { Dialog, Box, makeStyles } from '@material-ui/core';

import { Close } from '~/components/icons/Close';
import CustomPropertySelectWithCheckboxes from '~/views/components/CustomPropertySelectWithCheckboxes';
import CustomCompanySelectWithCheckboxes from '~/views/components/CustomCompanySelectWithCheckboxes';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      display: 'flex',
      width: '560px',
      padding: 'var(--utilities-size-none, 0px)',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'var(--utilities-size-none, 0px)',
      borderRadius: 'var(--utilities-border-radius-xl, 16px)',
      background: 'var(--background-surface-default, #FFF)',
      boxShadow:
        '0px 80px 80px -8px rgba(23, 28, 38, 0.05), 0px 48px 48px -8px rgba(23, 28, 38, 0.05), 0px 24px 24px -4px rgba(23, 28, 38, 0.05), 0px 12px 12px -2px rgba(23, 28, 38, 0.05), 0px 6px 6px 0px rgba(23, 28, 38, 0.05), 0px 2px 2px 0px rgba(23, 28, 38, 0.05)',
    },
  },
  titleSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-1-250, 20px) var(--utilities-size-1-500, 24px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  mainSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-none, 0px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px)',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-500, 24px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  title: {
    flex: '1 0 0',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  closeIcon: {
    width: 'var(--utilities-size-1-500)',
    height: 'var(--utilities-size-1-500)',
    cursor: 'pointer',
  },
  userSettingsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  buttonsSection: {
    display: 'flex',
    paddingTop: 'var(--utilities-size-1-500, 24px)',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    borderTop: '1px solid var(--border-default, rgba(23, 28, 38, 0.10))',
  },
  roleSection: {
    display: 'flex',
    paddingBottom: 'var(--utilities-size-1-000, 16px)',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-0-500, 8px)',
    alignSelf: 'stretch',
    borderBottom: '1px solid var(--border-default, rgba(23, 28, 38, 0.10))',
  },
  emailSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-0-500, 8px)',
    alignSelf: 'stretch',
  },
  nameSection: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
  },
  entitySection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-0-500, 8px)',
    alignSelf: 'stretch',
  },
  sectionTitle: {
    alignSelf: 'stretch',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-sm, 14px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-sm-line, 20px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  chooseRoleSelectContainer: {
    display: 'flex',
    width: '512px',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  chooseRoleSelect: {
    appearance: 'none',
    MozAppearance: 'none',
    WebkitAppearance: 'none',
    width: '100%',
    paddingLeft: 'var(--utilities-size-1-000, 16px)',
    backgroundImage: 'url(/public/static/icons/seenic/chevron-down.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px 20px',
    backgroundPosition: 'right 12px center',
    padding: '8px',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-control-default, rgba(23, 28, 38, 0.20))',
    background: 'var(--surface-default, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:focus, &:focus-visible': {
      outline: 'unset',
      backgroundImage: 'url(/public/static/icons/seenic/chevron-down.svg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '20px 20px',
      backgroundPosition: 'right 12px center',
      border: '1px solid var(--border-control-default, rgba(23, 28, 38, 0.20))',
      background: 'var(--surface-default, #FFF)',
      boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    },
  },
  roleDescription: {
    color: 'var(--content-secondary, #6B7280)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-sm, 14px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--typography-line-height-2xs-line, 12px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  inputContainer: {
    display: 'flex',
    height: '40px',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-0-750, 12px)',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    alignSelf: 'stretch',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-control-default, rgba(23, 28, 38, 0.20))',
    background: 'var(--surface-default, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
  },
  inputText: {
    flex: '1 0 0',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
    '&:focus, &:focus-visible': {
      outline: 'unset',
    },
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
  },
  cancelButton: {
    display: 'flex',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-accent-weak, rgba(70, 86, 229, 0.20))',
    background: 'var(--surface-accent-tint, rgba(70, 86, 229, 0.10))',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:hover': {
      border: '1px solid var(--border-hover-accent-weak-hover)',
      background: 'var(--surface-hover-accent-tint-hover)',
      cursor: 'pointer',
    },
  },
  cancelText: {
    color: 'var(--content-accent, #5E59F3)',
    textAlign: 'center',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  createButton: {
    display: 'flex',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    background: 'var(--surface-accent, #5E59F3)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:hover': {
      background: 'var(--surface-hover-accent-hover, #5646e5)',
      cursor: 'pointer',
    },
  },
  createText: {
    color: 'var(--content-inverted, #FFF)',
    textAlign: 'center',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  warningSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-0-500, 8px) var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    alignItems: 'center',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-danger-weak, rgba(239, 68, 68, 0.20))',
    background: 'var(--surface-danger-tint, rgba(239, 68, 68, 0.10))',
  },
  warningText: {
    flex: '1 0 0',
    color: 'var(--content-danger, #EF4444)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-sm, 14px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-sm-line, 20px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
}));

const CreateOrUpdateUserDialog = ({
  isSuperAdmin,
  authUser,
  open,
  onClose,
  setDialogOpen,
  companiesList,
  fullCompaniesList,
  initialData,
  handleCreateConfirmation,
  handleUpdateConfirmation,
}) => {
  const classes = useStyles();

  const [hoveredClose, setHoveredClose] = useState(null);
  const [role, setRole] = useState('superadmin');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [property, setProperty] = useState('');
  const [errors, setErrors] = useState({});
  const [mainError, setMainError] = useState('');
  const [propertiesList, setPropertiesList] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [formData, setFormData] = useState({});
  const [shouldRunEffect, setShouldRunEffect] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
      setRole(initialData.role);
      setEmail(initialData.email);
      setFirstName(initialData.firstName || '');
      setLastName(initialData.lastName || '');

      const selectedCompanyNames = initialData.companiesAccessList
        ? initialData.companiesAccessList.map(company => company.name)
        : [initialData.companyName];

      if (initialData.accessAllCompanies) {
        setSelectedCompanies(fullCompaniesList.map(company => company.name));
      } else {
        setSelectedCompanies(selectedCompanyNames);
      }

      const selectedPropertyNames = initialData.propertiesAccessList
        ? initialData.propertiesAccessList.map(property => property.name)
        : [];

      if (initialData.accessAllCompanies && initialData.accessAllProperties) {
        setSelectedProperties(
          fullCompaniesList
            .flatMap(company => company.properties)
            .map(property => property.name),
        );
      } else if (
        !initialData.accessAllCompanies &&
        initialData.accessAllProperties
      ) {
        setSelectedProperties(
          fullCompaniesList
            .filter(company => selectedCompanyNames.includes(company.name))
            .flatMap(company => company.properties)
            .map(property => property.name),
        );
      } else {
        setSelectedProperties(selectedPropertyNames);
      }
    }
    setErrors({});
  }, [initialData, open]);

  useEffect(() => {
    if (!open) {
      setRole(isSuperAdmin ? 'superadmin' : 'admin');
      setEmail('');
      setFirstName('');
      setLastName('');
      setCompany('');
      setProperty('');
      setSelectedCompanies([]);
      setSelectedProperties([]);
      setMainError('');
      setFormData({});
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      setErrors({});
    }
  }, [open]);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleConfirm = () => {
    const newErrors = {};

    if (!email) newErrors.email = 'Enter e-mail address.';
    if (!firstName) newErrors.firstName = 'Enter first name.';
    if (!lastName) newErrors.lastName = 'Enter last name.';
    if (!company && role !== 'superadmin')
      newErrors.company = 'Choose a company.';
    if (!property && role !== 'superadmin')
      newErrors.property = 'Choose a property.';

    setErrors(newErrors);

    const companiesAccessList = selectedCompanies.map(companyName => {
      const company = fullCompaniesList.find(c => c.name === companyName);
      return { id: company.id, name: company.name };
    });

    const propertiesAccessListSuperAdmin = selectedProperties.map(
      propertyName => {
        const property = propertiesList
          .flatMap(company => company.properties)
          .find(p => p.name === propertyName);

        return property ? { id: property.id, name: property.name } : undefined;
      },
    );

    const propertiesAccessListAdmin = selectedProperties.map(propertyName => {
      const property = fullCompaniesList
        .flatMap(company => company.properties)
        .find(p => p.name === propertyName);

      return { id: property.id, name: property.name };
    });

    const propertiesAccessList = isSuperAdmin
      ? propertiesAccessListSuperAdmin
      : propertiesAccessListAdmin;

    if (propertiesAccessList.some(item => item === undefined)) {
      setMainError('Something went wrong. Please try later.');
      return;
    } else {
      setMainError('');
    }

    if (Object.keys(newErrors).length === 0) {
      const isAllCompaniesSelected =
        selectedCompanies.length === fullCompaniesList.length;

      // const allPropertiesList = propertiesList.flatMap(obj =>
      //   obj.properties.map(property => property.name),
      // );

      // const isAllPropertiesSelectedSuperAdmin =
      //   selectedProperties.length === allPropertiesList.length;

      // const filteredPropertiesAccessList =
      //   initialData &&
      //   initialData.propertiesAccessList &&
      //   initialData.propertiesAccessList.filter(
      //     property => !allPropertiesList.includes(property.name),
      //   );

      // const isAllPropertiesSelectedAdmin =
      //   selectedProperties.length ===
      //   allPropertiesList.length +
      //     (filteredPropertiesAccessList
      //       ? filteredPropertiesAccessList.length
      //       : 0);

      const namesSet = new Set(selectedCompanies);
      const filteredProperties = fullCompaniesList.filter(({ name }) =>
        namesSet.has(name),
      );
      const filteredPropertiesNames = filteredProperties
        .flatMap(c => c.properties)
        .map(p => p.name);

      const allPropertiesSelected =
        filteredPropertiesNames.length === selectedProperties.length;

      const updatedFormData = {
        ...formData,
        email,
        firstName,
        lastName,
        role,
        accessAllCompanies: role === 'superadmin' || isAllCompaniesSelected,
        accessAllProperties: role === 'superadmin' || allPropertiesSelected,
        companyName: selectedCompanies[0],
        companiesAccessList: role === 'superadmin' ? [] : companiesAccessList,
        propertiesAccessList: role === 'superadmin' ? [] : propertiesAccessList,
      };

      if (initialData) {
        handleUpdateConfirmation(updatedFormData);
      } else {
        handleCreateConfirmation(updatedFormData);
      }
      setDialogOpen(false);
    }
  };

  const removeDuplicates = array => [...new Set(array)];

  useEffect(() => {
    const filteredObjects = companiesList.filter(obj =>
      selectedCompanies.includes(obj.name),
    );

    setPropertiesList(selectedCompanies.length > 0 ? filteredObjects : []);

    setCompany(selectedCompanies.length > 0 ? 'Choose a company.' : '');
  }, [selectedCompanies]);

  useEffect(() => {
    setProperty(selectedProperties.length > 0 ? 'Choose a property.' : '');
  }, [selectedProperties]);

  useEffect(() => {
    if (!shouldRunEffect) return;

    const namesSet = new Set(selectedCompanies);
    const filteredProperties = fullCompaniesList.filter(({ name }) =>
      namesSet.has(name),
    );
    const filteredPropertiesNames = filteredProperties
      .flatMap(c => c.properties)
      .map(p => p.name);

    setSelectedProperties(filteredPropertiesNames);
    setShouldRunEffect(false);
  }, [shouldRunEffect]);

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <Box className={classes.titleSection}>
        <Box className={classes.title}>
          {initialData ? 'User management' : 'New user'}
        </Box>
        <Box
          className={classes.closeIcon}
          onClick={handleClose}
          onMouseEnter={() => setHoveredClose(true)}
          onMouseLeave={() => setHoveredClose(null)}
        >
          <Close color={hoveredClose ? '#2C313A' : '#7c7e83'} />
        </Box>
      </Box>
      <Box className={classes.mainSection}>
        <Box className={classes.userSettingsSection}>
          {mainError && (
            <Box className={classes.warningSection}>
              <Box className={classes.warningText}>{mainError}</Box>
            </Box>
          )}
          <Box className={classes.roleSection}>
            <Box className={classes.sectionTitle}>Role</Box>
            <Box className={classes.chooseRoleSelectContainer}>
              <select
                className={classes.chooseRoleSelect}
                onChange={e => {
                  setFormData({ ...formData, role: e.target.value });
                  setRole(e.target.value);
                }}
                value={formData.role || role}
              >
                {isSuperAdmin && (
                  <option value="superadmin">Super Admin</option>
                )}
                <option value="admin">Admin</option>
                <option value="client">Client</option>
              </select>
            </Box>
            <Box className={classes.roleDescription}>
              Super Admins have access to full user management.
            </Box>
            <Box className={classes.roleDescription}>
              Admins can only manage admins and clients.
            </Box>
            <Box className={classes.roleDescription}>
              Clients cannot manage users.
            </Box>
          </Box>
          <Box className={classes.emailSection}>
            <Box className={classes.sectionTitle}>Email</Box>
            <Box className={classes.inputContainer}>
              <input
                type="email"
                className={classes.inputText}
                value={formData.email || email}
                onChange={e => {
                  setFormData({ ...formData, email: e.target.value });
                  setEmail(e.target.value);
                }}
              />
            </Box>
            {errors.email && (
              <Box className={classes.warningSection}>
                <Box className={classes.warningText}>{errors.email}</Box>
              </Box>
            )}
          </Box>
          <Box className={classes.nameSection}>
            <Box className={classes.nameContainer}>
              <Box className={classes.sectionTitle}>First name</Box>
              <Box className={classes.inputContainer}>
                <input
                  type="text"
                  className={classes.inputText}
                  value={formData.firstName || firstName}
                  onChange={e => {
                    setFormData({ ...formData, firstName: e.target.value });
                    setFirstName(e.target.value);
                  }}
                />
              </Box>
              {errors.firstName && (
                <Box className={classes.warningSection}>
                  <Box className={classes.warningText}>{errors.firstName}</Box>
                </Box>
              )}
            </Box>
            <Box className={classes.nameContainer}>
              <Box className={classes.sectionTitle}>Last name</Box>
              <Box className={classes.inputContainer}>
                <input
                  type="text"
                  className={classes.inputText}
                  value={formData.lastName || lastName}
                  onChange={e => {
                    setFormData({ ...formData, lastName: e.target.value });
                    setLastName(e.target.value);
                  }}
                />
              </Box>
              {errors.lastName && (
                <Box className={classes.warningSection}>
                  <Box className={classes.warningText}>{errors.lastName}</Box>
                </Box>
              )}
            </Box>
          </Box>
          {role !== 'superadmin' && (
            <>
              <Box className={classes.entitySection}>
                <Box className={classes.sectionTitle}>Company</Box>
                <Box className={classes.chooseRoleSelectContainer}>
                  <CustomCompanySelectWithCheckboxes
                    label="company"
                    options={
                      isSuperAdmin
                        ? companiesList.map(company => company.name)
                        : removeDuplicates([
                            ...selectedCompanies,
                            ...authUser.companiesAccessList.map(
                              company => company.name,
                            ),
                          ])
                    }
                    authUser={authUser}
                    selectedValues={selectedCompanies}
                    setSelectedValues={values => {
                      setSelectedCompanies(values);
                      setShouldRunEffect(true);
                    }}
                  />
                </Box>
                {errors.company && (
                  <Box className={classes.warningSection}>
                    <Box className={classes.warningText}>{errors.company}</Box>
                  </Box>
                )}
              </Box>
              <Box className={classes.entitySection}>
                <Box className={classes.sectionTitle}>Property</Box>
                <Box className={classes.chooseRoleSelectContainer}>
                  <CustomPropertySelectWithCheckboxes
                    label="property"
                    options={
                      selectedCompanies.length > 0
                        ? isSuperAdmin
                          ? propertiesList.flatMap(obj =>
                              obj.properties.map(property => property.name),
                            )
                          : removeDuplicates([
                              ...propertiesList.flatMap(obj =>
                                obj.properties.map(property => property.name),
                              ),
                              ...selectedProperties,
                            ])
                        : []
                    }
                    authUser={authUser}
                    selectedValues={
                      isSuperAdmin
                        ? selectedProperties
                        : removeDuplicates(selectedProperties)
                    }
                    setSelectedValues={setSelectedProperties}
                    emptyList={propertiesList.length === 0}
                  />
                </Box>
                {errors.property && (
                  <Box className={classes.warningSection}>
                    <Box className={classes.warningText}>{errors.property}</Box>
                  </Box>
                )}
              </Box>
            </>
          )}
        </Box>
        <Box className={classes.buttonsSection}>
          <Box className={classes.cancelButton} onClick={handleClose}>
            <Box className={classes.cancelText}>Cancel</Box>
          </Box>
          <Box className={classes.createButton} onClick={handleConfirm}>
            <Box className={classes.createText}>
              {initialData ? 'Update' : 'Create'}
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CreateOrUpdateUserDialog;
